/**
 * Created by Ning Jiang on 2021-05-03.
 */

import {NolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/NolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {IFadeTrackConf, IPlayTrackConf} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {ShootingController} from "../view/ShootingController";
import {SoundEffectGroup} from "./SoundEffectGroup";
import {gsap} from "gsap";

export class TombstoneRipSound {

    public static REELS_SPINNING:string = "reelsSpinning";
    public static REELS_LANDING:string[] = ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5"];
    public static SUPER_FS_REELS_LANDING:string[] = ["reelLandingSFS1", "reelLandingSFS2", "reelLandingSFS3", "reelLandingSFS4", "reelLandingSFS5"];
    public static MAIN_GAME_MUSIC:string = "background-music-main";

    // count up sounds
    public static INITIAL_COUNT_UP_COUNTER:string = "countupCounter";
    public static INITIAL_COUNT_UP_MULTI:string = "countupMultiplier";
    public static INITIAL_COUNT_UP_END_LARGE:string = "countupEndsLarge";
    public static INITIAL_COUNT_UP_END_MEDIUM:string = "countupEndsMedium";
    public static INITIAL_COUNT_UP_END_SMALL:string = "countupEndsSmall";
    public static INITIAL_COUNT_UP_END_TINY:string = "countupEndsTiny";

    public static INITIAL_LARGE:string = "countupSweepLarge";
    public static INITIAL_MEDIUM:string = "countupSweepMedium";
    public static INITIAL_SMALL:string = "countupSweepSmall";
    public static INITIAL_TINY:string = "countupSweepTiny";
    public static INITIAL_MORE_BETWINS:string = "countupSweepToggle";

    public static ENHANCE_ON:string = "enhancedbetOn";
    public static ENHANCE_OFF:string = "enhancedbetOff";

    public static REGULAR_W_LAND:string[] = ["", "wildRegularLandReel2", "wildRegularLandReel3", "wildRegularLandReel4", "wildRegularLandReel5"];
    public static WRS_LAND:string = "wildReelsplitLand";
    public static WRS_SPLIT:string = "wildReelsplitChop";
    public static WRS_SPLIT_REEL:string = "wildReelsplitSplit";
    public static WXS_LAND:string = "xsplitLand";
    public static WXS_SPLIT:string = "xsplitReel5";
    public static WXS_SPLIT_OTHER:string = "xsplitReels";

    public static SCATTER_LAND_1:string = "scatter1Land";
    public static SCATTER_LAND_1_ENHANCED:string = "scatter1LandEnhanced";
    public static SCATTER_LAND_2:string = "scatter2Land";
    public static SCATTER_LAND_3:string = "scatter3Land";
    public static SCATTER_LAND_4:string = "scatter4Land";
    public static SCATTER_ANTICIPATION_FS:string = "scatterAnticipationFS";
    public static SCATTER_ANTICIPATION_FS_SUPER:string = "scatterAnticipationSFS";
    public static SCATTER_ANTICIPATION_FAIL:string = "scatterAnticipationFail";
    public static SCATTER_WIN:string = "scatterBump";

    public static RESPIN_S2_LAND:string = "scatterRespinLand";
    public static RESPIN_S2_LAND_NO_RESPIN:string = "scatterBoothillLand";
    public static RESPIN_SPIN:string = "reel5Spin";
    public static RESPIN_LOOP:string = "scatterRespinLoop";
    public static SYMBOL_TO_WILD:string = "symbolToWild";
    public static POP_UP_SHUFFLE:string = "multiplierSpin";
    public static POP_UP_SYMBOL_LAND:string = "multiplierLand";
    public static POP_UP_MOVE:string = "multiplierMove";
    public static MATCH_EXPLOSION:string = "wildMultiplier";
    public static REELS_ON_FIRE:string = "reelsFireLoop";
    public static SUPER_FS_MUL_M_LAND:string = "wildMidSymbolLand";
    public static SUPER_FS_M_FIRE_LAND:string = "wildMidSymbolMultLand";

    public static FS_MUSIC:string = "fsLoop";
    public static FS_INTRO_MUSIC:string = "fsIntroLoop";
    public static FS_INTRO_TRANSITION:string = "fsIntroTransition";
    public static FS_INTRO_START:string = "fsIntroStart";
    public static FS_BUTTON:string = "fsStart";
    public static FS_END:string = "fsEnd";

    public static SUPER_FS_MUSIC:string = "sfsLoop";
    public static SUPER_FS_INTRO:string = "sfsIntroRepeat";
    public static SUPER_FS_INTRO_TRANSITION:string = "sfsIntroTransition";
    public static SUPER_FS_INTRO_START:string = "sfsIntroStart";
    public static SUPER_FS_BUTTON:string = "sfsStart";
    public static SUPER_FS_END:string = "sfsEnd";

    public static WIN_CAP:string = "capWinRepeat";
    public static WIN_CAP_COUNT_UP:string = "capWinCountup";

    public static MULTIPLIER:string[] = ["multiplier1", "multiplier2", "multiplier3", "multiplier4", "multiplier5"];

    public static BIG_WIN:string[] = ["bigwin1", "bigwin2", "bigwin3", "bigwin4", "bigwin5"];
    public static BIG_WIN_END:string = "bigwinEnd";
    public static BIG_WIN_SUPER:string[] = ["bigwinSFS1", "bigwinSFS2", "bigwinSFS3", "bigwinSFS4", "bigwinSFS5"];
    public static BIG_WIN_END_SUPER:string = "bigwinSFSEnd";
    public static BIG_WIN_NEAR_WIN:string = "bigwinAnticipation";
    public static BIG_WIN_NEAR_WIN_SUPER:string = "bigWinSFSAnticipation";
    static AS_WIN:string = "asWin";
    static AS_WIN_BIG:string = "asWinBig";

    public static get soundPlayer():NolimitAudioPlayer {
        return <NolimitAudioPlayer>SlotGame.sound;
    }

    private static _currentMusic:string;

    public static switchMusic(conf:IPlayTrackConf, fadeInConf?:IFadeTrackConf, fadeOutConf?:IFadeTrackConf):void {
        // Logger.logDev(`switchMusic: from ${TombstoneRipSound._currentMusic} to ${conf.name}, fadeIn to ${fadeInConf?.to}, fadeout in ${fadeOutConf?.duration}`);
        if(conf.name === TombstoneRipSound._currentMusic) {
            if(fadeInConf) {
                TombstoneRipSound.fadeMusic(fadeInConf.to, fadeInConf.duration);
            } else if(conf.volume) {
                TombstoneRipSound.fadeMusic(conf.volume, 1);
            }
            return;
        }

        if(TombstoneRipSound._currentMusic != null) {
            if(fadeOutConf) {
                fadeOutConf.name = this._currentMusic;
                // Logger.logDev(`switchMusic: try fade out ${fadeOutConf.name} in ${fadeOutConf.duration}`);
                const fade = TombstoneRipSound.soundPlayer.fadeTrack(fadeOutConf);
                const fadeName = fadeOutConf.name;
                if(fade) {
                    // Logger.logDev(`switchMusic: fading out ${fadeOutConf.name} in ${fadeOutConf.duration}`);
                    gsap.to(this, {
                        duration : fadeOutConf.duration / 1000, onComplete : () => {
                            // Logger.logDev(`switchMusic: stop faded out sound ${fadeName}`);
                            TombstoneRipSound.soundPlayer.stopTrack(fadeName);
                        }
                    });
                } else {
                    // Logger.logDev(`switchMusic: cannot fade out ${fadeOutConf.name} in ${fadeOutConf.duration}, stop it!`);
                    TombstoneRipSound.soundPlayer.stopTrack(fadeName);
                }
            } else {
                // Logger.logDev(`switchMusic: no fade out, stop ${TombstoneRipSound._currentMusic} directly`);
                TombstoneRipSound.soundPlayer.stopTrack(TombstoneRipSound._currentMusic);
            }
        }

        // Logger.logDev(`switchMusic: play sound ${conf.name}`);
        TombstoneRipSound.soundPlayer.playTrack(conf);
        if(fadeInConf) {
            fadeInConf.name = conf.name;
            TombstoneRipSound.soundPlayer.fadeTrack(fadeInConf);
        }
        TombstoneRipSound._currentMusic = conf.name;
    }

    // Use this to handle the music, eg, fade out/in music in big win, and you don't need to care what music is playing
    public static fadeMusic(vol:number, duration:number):void {
        TombstoneRipSound.soundPlayer.fadeTrack({
            name : TombstoneRipSound._currentMusic,
            to : vol,
            duration : duration
        });
    }

    public static fadeAndStopSound(fadeOutConf:IFadeTrackConf):void {
        const fade = TombstoneRipSound.soundPlayer.fadeTrack(fadeOutConf);
        if(fade) {
            gsap.to(this, {
                duration : fadeOutConf.duration / 1000,
                onComplete : () => {TombstoneRipSound.soundPlayer.stopTrack(fadeOutConf.name)}
            });
        } else {
            TombstoneRipSound.soundPlayer.stopTrack(fadeOutConf.name);
        }
    }

    private static _shotgunFireGroup:SoundEffectGroup;
    private static _rifleFireGroup:SoundEffectGroup;

    public static playGunShot(type:string):void {
        if(type === ShootingController.GUN_SHOTGUN) {
            if(!TombstoneRipSound._shotgunFireGroup) {
                TombstoneRipSound._shotgunFireGroup = new SoundEffectGroup([
                    "shotgunFire01", "shotgunFire02", "shotgunFire03", "shotgunFire04"
                ]);
            }
            TombstoneRipSound._shotgunFireGroup.play();
        } else {
            if(!TombstoneRipSound._rifleFireGroup) {
                TombstoneRipSound._rifleFireGroup = new SoundEffectGroup([
                    "rifleFire01", "rifleFire02", "rifleFire03", "rifleFire04"
                ]);
            }
            TombstoneRipSound._rifleFireGroup.play();
        }
    }

    private static _xNudgeLandGroup:SoundEffectGroup;

    public static playNudgeLand():void {
        if(!TombstoneRipSound._xNudgeLandGroup) {
            TombstoneRipSound._xNudgeLandGroup = new SoundEffectGroup([
                "xnudgeLand", "xnudgeLand", "xnudgeLand", "xnudgeLand"
            ]);
        }
        TombstoneRipSound._xNudgeLandGroup.play();
    }

    private static _nudgeMiddleGroup:SoundEffectGroup;

    public static playNudgeMiddle():void {
        if(!TombstoneRipSound._nudgeMiddleGroup) {
            TombstoneRipSound._nudgeMiddleGroup = new SoundEffectGroup([
                "xnudgeNudgeMiddle", "xnudgeNudgeMiddle", "xnudgeNudgeMiddle", "xnudgeNudgeMiddle"
            ]);
        }
        TombstoneRipSound._nudgeMiddleGroup.play();
    }

    private static _nudgeEndGroup:SoundEffectGroup;

    public static playNudgeEnd():void {
        if(!TombstoneRipSound._nudgeEndGroup) {
            TombstoneRipSound._nudgeEndGroup = new SoundEffectGroup([
                "xnudgeNudgeFinal", "xnudgeNudgeFinal", "xnudgeNudgeFinal", "xnudgeNudgeFinal"
            ]);
        }
        TombstoneRipSound._nudgeEndGroup.play();
    }

    private static _entryScreamGroup:SoundEffectGroup;

    public static playScream():void {
        if(!TombstoneRipSound._entryScreamGroup) {
            TombstoneRipSound._entryScreamGroup = new SoundEffectGroup([
                "scream01", "scream02", "scream03"
            ]);
        }
        TombstoneRipSound._entryScreamGroup.play();
    }
}